import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { apiUrl } from '../core/api-client';
import { CurrentUser, PlatformApi, PublicIqHistory } from '../core/platform-api';
import {
  DsAlertComponent,
  DsButtonDirective,
  DsCardDirective,
  DsInputDirective,
  DsStateComponent,
} from '../ui';

@Component({
  selector: 'app-account-page',
  imports: [
    DatePipe,
    FormsModule,
    DsAlertComponent,
    DsButtonDirective,
    DsCardDirective,
    DsInputDirective,
    DsStateComponent,
  ],
  templateUrl: './account-page.html',
  styleUrl: './account-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountPage implements OnInit {
  private readonly api = inject(PlatformApi);
  protected readonly user = signal<CurrentUser | null>(null);
  protected readonly history = signal<PublicIqHistory[]>([]);
  protected readonly email = signal('');
  protected readonly loading = signal(true);
  protected readonly sent = signal(false);
  protected readonly error = signal('');

  async ngOnInit(): Promise<void> {
    try {
      const user = await this.api.getCurrentUser();
      this.user.set(user);
      this.history.set(await this.api.listPublicIqHistory());
    } catch {
      this.user.set(null);
    } finally {
      this.loading.set(false);
    }
  }

  protected async sendLink(): Promise<void> {
    if (!this.email().includes('@')) return;
    this.error.set('');
    try {
      await this.api.requestMagicLink(this.email(), '/account');
      this.sent.set(true);
    } catch {
      this.error.set('We could not send the sign-in link. Please try again.');
    }
  }

  protected async logout(): Promise<void> {
    await this.api.logout();
    this.user.set(null);
    this.history.set([]);
  }

  protected certificateUrl(id: string): string {
    return apiUrl(`/api/v1/public-iq-tests/${id}/certificate.pdf`);
  }
}
